import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Verweise auf einen Aussteller oder Beruf tragen einen Anker
// (/…/aussteller-berufe/#aussteller-<id>, /…/themen/#beruf-<id>). Der Browser
// wertet ihn beim Eintreffen aus — da hat React die Liste noch nicht gerendert,
// das Ziel existiert nicht und der Sprung verfaellt. Darum wird gescrollt, sobald
// die Daten stehen (#53).
export const useHashScroll = (ready) => {
    const { hash } = useLocation()

    useEffect(() => {
        if (!ready || !hash) return

        const target = document.getElementById(hash.slice(1))
        if (target) target.scrollIntoView({ block: 'start' })
    }, [hash, ready])
}
